import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogDetailModule } from '../change-log-detail/change-log-detail.module';
import { ChangeLogPipesModule } from '../../pipes/change-log-pipes.module';
import { ChangeLogDetailByTypeModule } from '../change-log-detail-by-type/change-log-detail-by-type.module';
import { AgentAssociationsInfoLogDetailsComponent } from './agent-associations-info-log-details.component';
import {
  ChangeLogFlightPreferenceGridModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/change-log-detail/flight-preference-grid/change-log-flight-preference-grid.module';
import {
  AgentChangeLogDetailsByTypeModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/agent-info-log-details/agent-change-log-details-by-type/agent-change-log-details-by-type.module';
import {
  ChangeLogAssociationModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/change-log-detail/association/change-log-association.module';
import {
  ChangeLogAddressModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/change-log-detail/address/change-log-address.module';
import {
  ChangeLogAddressGridModule
} from 'ag-common-svc/lib/components/changes-history-grid/components/change-log-detail/address-grid/change-log-address-grid.module';

@NgModule({
  declarations: [AgentAssociationsInfoLogDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    ChangeLogDetailModule,
    ChangeLogPipesModule,
    ChangeLogDetailByTypeModule,
    ChangeLogFlightPreferenceGridModule,
    AgentChangeLogDetailsByTypeModule,
    ChangeLogAssociationModule,
    ChangeLogAddressModule,
    ChangeLogAddressGridModule,
  ],
  exports: [AgentAssociationsInfoLogDetailsComponent],
})
export class AgentAssociationsInfoLogDetailsModule {}
